var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7114 3.64505C22.6441 0.578279 17.6532 0.578279 14.5864 3.64505C14.5341 3.69884 9.07568 9.15581 9.07568 9.15581C10.0159 10.2014 11.6601 10.2586 12.6547 9.2576L15.8864 6.02584L24.3159 14.4553C24.6202 14.7596 24.8418 15.1186 24.9803 15.5011L25.7114 14.77C28.7631 11.8418 28.7628 6.57292 25.7114 3.64505Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1551 15.616C21.4931 13.9539 17.6187 10.0796 15.8863 8.34719L13.8153 10.4182C13.0157 11.2178 11.9656 11.6173 10.9154 11.6173C9.86525 11.6173 8.81509 11.2178 8.01556 10.4182C8.00188 10.3982 6.80921 9.21606 6.75361 9.15575L12.8144 3.095C9.72789 0.590805 5.17152 0.774132 2.30013 3.64498C-0.96956 6.89316 -0.694733 12.2099 2.7516 15.2214C4.49978 13.3049 7.65635 14.5079 7.66861 17.0919C9.18524 17.0595 10.5146 18.3898 10.4825 19.9058C11.7832 19.8736 13.0329 20.8963 13.2478 22.1944C14.1769 21.9588 15.2249 22.2293 15.9041 22.9256L15.9047 22.925C16.1252 23.1461 16.4185 23.2676 16.731 23.2676C17.7635 23.2715 18.2894 22.002 17.5573 21.2723C17.317 21.0319 15.2995 19.0146 15.1183 18.8332C15.4395 18.512 15.955 17.9972 16.279 17.6725L18.718 20.1116C18.9386 20.3322 19.2325 20.4536 19.5444 20.4536C20.5773 20.4579 21.1035 19.1881 20.3707 18.4589L17.9317 16.0199C18.2212 15.7307 18.8037 15.1485 19.0929 14.8591C19.0931 14.8599 21.5335 17.2999 21.5342 17.301C21.9836 17.7623 22.7737 17.7484 23.2077 17.2741C23.2135 17.2677 23.2515 17.2297 23.2585 17.2227L23.2558 17.2189C23.6351 16.7614 23.5962 16.0576 23.1551 15.616Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7669 24.1099C14.7593 24.1017 14.7516 24.094 14.7434 24.0863C14.2939 23.6279 13.5309 23.6434 13.0622 24.1132L12.521 24.6549C11.4699 25.7959 13.0324 27.3588 14.1737 26.3076L14.7428 25.7385C15.1873 25.3123 15.1978 24.5479 14.7669 24.1099Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4868 21.5467C10.1875 21.5467 9.88812 21.6605 9.66046 21.8881L8.58184 22.9668C7.53053 24.1081 9.09373 25.6707 10.2345 24.6194L11.3131 23.5408C12.0489 22.8092 11.5136 21.5394 10.4868 21.5467Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68582 17.9139C6.42175 17.1813 5.88589 15.9128 4.85948 15.9192C4.56068 15.9192 4.26134 16.0336 4.03313 16.2612L2.95451 17.3399C1.90468 18.4819 3.46455 20.0426 4.6072 18.9925L5.68582 17.9139Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 19.0746C8.04363 18.6194 7.30293 18.6193 6.84724 19.0746C6.34459 19.5788 5.32403 20.5967 4.82407 21.0978C4.36821 21.5537 4.36821 22.2946 4.82407 22.7505C5.27993 23.2063 6.0209 23.2058 6.47675 22.7505L8.49992 20.7273C8.95523 20.272 8.95523 19.5305 8.49992 19.0746Z",
    fill: "#2A323F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1);
export default __webpack_public_path__ + "static/media/v1.8fff5aa0afbbb442b4a21b790b633365.svg";
export { ForwardRef as ReactComponent };